<template>
  <div>
    <form @submit.prevent="saveCompany">
      <h5 v-translate>Default Commission</h5>
      <b-form-row>
        <b-col cols="12">
          <label for="change-status" v-translate>Courier Commission Percentage to show in app</label>
        </b-col>
        <b-col lg="6" xl="5" class="align-self-center">
          <b-input-group append="%">
            <b-form-input class="m-0" v-model="company.courier_commission_percentage" type="number" step=".01" min="0" max="100" :disabled="hideCourierCommissionPercentage" :required="hideCourierCommissionPercentage === false" />
          </b-input-group>
        </b-col>
        <b-col class="align-self-center">
          <b-form-checkbox v-model="hideCourierCommissionPercentage" :value="true" :unchecked-value="false">
            <translate>Hide Courier Commission in App</translate>
          </b-form-checkbox>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col cols="12" class="text-center form-actions">
          <b-form-group>
            <b-button size="md" :variant="commissionHasChanges ? 'secondary' : 'dark'" :disabled="!commissionHasChanges" type="submit">
              <b-spinner small v-if="updating"></b-spinner>
              <translate>Save Changes</translate>
            </b-button>
          </b-form-group>
        </b-col>
      </b-form-row>
    </form>
  </div>
</template>

<script>
export default {
  name: 'CompanySettingsForm',
  data() {
    return {
      company: {},
      hash: null,
      updating: false,
      hideCourierCommissionPercentage: null
    }
  },
  computed: {
    commissionHasChanges() {
      return JSON.stringify(this.company) !== this.hash
    }
  },
  watch: {
    hideCourierCommissionPercentage(val) {
      if (val) {
        this.company.courier_commission_percentage = null
      }
    },
    'company.courier_commission_percentage': {
      handler (val) {
        if (!val) {
          this.hideCourierCommissionPercentage = true
        }
      },
      deep: true
    }
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      this.company = this.profile.company
      this.hash = JSON.stringify({...this.company})
    },
    saveCompany() {
      this.updating = true
      this.$http.patch(this.$appConfig.api.baseUrl + 'companies/' + this.profile.company_id, {courier_commission_percentage: this.company.courier_commission_percentage})
        .then(response => {
          this.$store.dispatch('fetchProfile')
            .then(response => {
              if (this.$store.getters.profile.company_id) {
                this.init()
                this.updating = false
                this.makeToast(this.$gettext('Success'), this.$gettext('The Default Commission has been updated! 👍'), 'success', false, 4000)
              }
            })
        })
    },
    emitSuccess() {
      this.$emit('success', true)
    },
    emitCancel() {
      this.$emit('cancel', true)
    }
  }
}
</script>

<style lang="scss" scoped>
.input-group-append {
  .input-group-text {
    padding: 0.3rem 0.75rem;
    border-top-width: 0;
    font-size: 1em !important;
  }
}
</style>
